import { isString } from "@grandvisionhq/utils";
import { getUrl } from "../../../../utils/utils/get-url.js";
const parselinkConfigurator = (linkConfigurator, page) => {
  return {
    label: linkConfigurator?.linkSelector.label ?? "",
    url: getUrl(linkConfigurator?.linkSelector.url, page) ?? "",
    icon: linkConfigurator?.icon ?? ""
  };
};
const PARAMETER_HIDDEN = "com.onehippo.cms7.targeting.TargetingParameterUtil.hide";
const omitKeysContent = ["displayName", "versionedNode", "_links", "localeString"];
const omitKeysMeta = [PARAMETER_HIDDEN, "document", "mobile", "tablet", "desktop"];
function parseBloomreachContent(content = {}) {
  return Object.keys(content).reduce(
    (result, key) => omitKeysContent.includes(key) ? result : { ...result, [key]: content[key] },
    {}
  );
}
function parseBloomreachMeta(meta) {
  return Object.keys(meta).reduce(
    (result, key) => omitKeysMeta.includes(key) ? result : { ...result, [key]: meta[key] },
    {}
  );
}
const getCommonParams = ({ title, theme, template }) => ({
  ...isString(title) ? { title } : {},
  ...isString(theme) ? { theme } : {},
  ...isString(template) ? { template } : {}
});
async function fetchPagedComponent(url, componentId, pageIndex = 1, path = "/blog") {
  const response = await fetch(
    `${url}/resourceapi${path}?_hn%3Atype=component-rendering&_hn%3Aref=${componentId}&page=${pageIndex}`,
    {
      method: "GET",
      headers: {
        "Accept-Version": "1.0"
      }
    }
  );
  return response.json();
}
export {
  fetchPagedComponent,
  getCommonParams,
  parseBloomreachContent,
  parseBloomreachMeta,
  parselinkConfigurator
};
//# sourceMappingURL=helpers.js.map
